import { useState } from 'react';

export const useSelectEvents = () => {
  const [isMouseOver, setIsMouseOver] = useState<boolean>(false);
  const [isMenuItemClicked, setIsMenuItemClicked] = useState<boolean>(false);

  const showOptions = () => {
    setIsMouseOver(true);
    setIsMenuItemClicked(false);
  };

  const hideOnMouseOut = () => {
    setIsMouseOver(false);
  };

  const hideOnClick = () => {
    setIsMenuItemClicked(true);
    setIsMouseOver(false);
  };

  return { isMouseOver, isMenuItemClicked, showOptions, hideOnMouseOut, hideOnClick };
};
